import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { FormHelperText } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import InputGroupV2 from '../InputGroupV2';
import CreatableSelect from 'react-select/creatable';
import { getReactSelectStyles } from '../reactSelectTheme';
import { useReactSelectTabBlur } from '../reactSelectTabSelect';

const CreatableSelectV2 = ({
  label,
  onChange,
  placement,
  title,
  useTooltip,
  isRequired,
  options,
  value,
  error,
  disabled,
  placeholder,
}) => {
  const theme = useTheme();
  const { selectRef, tabSelectsValue, onKeyDown } = useReactSelectTabBlur();
  const selectStyles = useMemo(
    () => getReactSelectStyles(theme, { menuZIndex: 99999, error }),
    [theme, error]
  );

  const DropdownIndicator = () => (
    <ArrowDropDownIcon sx={{ color: 'text.secondary' }} />
  );
  const IndicatorSeparator = () => '';

  return (
    <InputGroupV2
      label={label}
      placement={placement}
      title={title}
      useTooltip={useTooltip}
      isRequired={isRequired}
    >
      <CreatableSelect
        ref={selectRef}
        components={{ DropdownIndicator, IndicatorSeparator }}
        styles={selectStyles}
        options={options}
        onChange={onChange}
        onKeyDown={onKeyDown}
        tabSelectsValue={tabSelectsValue}
        value={value}
        isDisabled={disabled}
        isClearable
        placeholder={placeholder}
        noOptionsMessage={() => 'Sem opções'}
        formatCreateLabel={(inputText) => `Criar "${inputText}"`}
        menuPlacement="auto"
        menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
      />
      {error && (
        <FormHelperText error sx={{ mx: 1.5, mt: 1 }}>
          O campo é obrigatório
        </FormHelperText>
      )}
    </InputGroupV2>
  );
};

CreatableSelectV2.propTypes = {
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.array.isRequired,
  value: PropTypes.object,
  placement: PropTypes.string,
  title: PropTypes.string,
  useTooltip: PropTypes.bool,
  isRequired: PropTypes.bool,
  error: PropTypes.bool,
  disabled: PropTypes.bool,
  placeholder: PropTypes.string,
};

CreatableSelectV2.defaultProps = {
  value: null,
  placement: '',
  title: '',
  useTooltip: false,
  isRequired: false,
  error: false,
  disabled: false,
  placeholder: 'Selecione ou crie...',
};

export default CreatableSelectV2;
